module.exports = __webpack_public_path__ + "static/img/img-p2-3gs.e1ba02bc.jpg";